import { useState, useEffect } from 'react';
import { i18n } from '../utils/i18n';

export const useTranslation = () => {
  const [language, setLanguage] = useState(i18n.getLanguage());

  useEffect(() => {
    const unsubscribe = i18n.subscribe(() => {
      setLanguage(i18n.getLanguage());
    });

    return unsubscribe;
  }, []);

  return {
    t: (key, params) => i18n.t(key, params),
    i18n: {
      changeLanguage: (lng) => i18n.changeLanguage(lng),
      language: language
    }
  };
};